<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("lbl.pelletizing.qualityResult.selfTestPelletizingPelList") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.pelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/selfTestPelletizingPel', query:{id: selfTestId}}">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingPel')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizingPel/edit">
              <span>{{$t('tlt.pelletizing.selfTestPelletizingPel.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="BackToList()"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="Save('selfTestPelletizingPel')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.shiftPlanNum')}}:
                </label>
                <input
                  disabled="disabled"
                  v-validate="'required'"
                  name="selfTestCode"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('selfTestCode') }"
                  v-model="selfTestCode"
                  type="text"
                />
                <span
                  v-show="errors.has('selfTestCode')"
                  class="lbl-obg"
                >{{ errors.first('selfTestCode') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.analysisTime')}}：
                </label>
                <mmf-datepicker disabled="disabled" v-model="analysisTime"></mmf-datepicker>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.moistureQh')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="moistureQh"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('moistureQh') }"
                  v-model="moistureQh"
                  type="text"
                />
                <span
                  v-show="errors.has('moistureQh')"
                  class="lbl-obg"
                >{{ errors.first('moistureQh') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.moistureSq')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="moistureSq"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('moistureSq') }"
                  v-model="moistureSq"
                  type="text"
                />
                <span
                  v-show="errors.has('moistureSq')"
                  class="lbl-obg"
                >{{ errors.first('moistureSq') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.compressionDry')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="compressionDry"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('compressionDry') }"
                  v-model="compressionDry"
                  type="text"
                />
                <span
                  v-show="errors.has('compressionDry')"
                  class="lbl-obg"
                >{{ errors.first('compressionDry') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.compressionWet')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="compressionWet"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('compressionWet') }"
                  v-model="compressionWet"
                  type="text"
                />
                <span
                  v-show="errors.has('compressionWet')"
                  class="lbl-obg"
                >{{ errors.first('compressionWet') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.pelSize')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="pelSize"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('pelSize') }"
                  v-model="pelSize"
                  type="text"
                />
                <span v-show="errors.has('pelSize')" class="lbl-obg">{{ errors.first('pelSize') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizingPel.checkUser')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="checkUser"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('checkUser') }"
                  v-model="checkUser"
                  type="text"
                />
                <span
                  v-show="errors.has('checkUser')"
                  class="lbl-obg"
                >{{ errors.first('checkUser') }}</span>
              </div>
              <!-- <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.selfTestPelletizingPel.status')}}:</label>
                                <input   v-validate="'required'" name="status"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('status') }"
                                    v-model="status" type="text">
                                <span v-show="errors.has('status')" class="lbl-obg">
                                    {{ errors.first('status') }}
                                </span>
              </div>-->
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { fields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingPel";
import MmfDatepicker from "@/components/MmfDatepicker";
// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizingPel/getField",
  mutationType: "selfTestPelletizingPel/updateField"
});

export default {
  name: "selfTestPelletizingPelEdit",
  data() {
    return {};
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.selfTestPelletizingPel.rows,

      entity: state => state.selfTestPelletizingPel.entity,

      selfTestId: state => state.selfTestPelletizingPel.selfTestId
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList"]),

    ...mapActions("selfTestPelletizingPel", ["Save","BackToList"])
  },

  components: {
    MmfDatepicker
  }
};
</script>
